/** Pole danych osoby zapisującej, którego dotyczy wiersz rachunku. */
export enum ClientBillField {
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  /**
   * Trzy pola `AddressDto`, a nie jedno „ADDRESS”: kontrakt trzyma je osobno
   * (`ClientDetailsDto`), więc formularz pyta o każde z nich
   * z osobna. Wiersz „Adres” wymienia całą trójkę i jest przez to zwykłym
   * wierszem wielopolowym — takim samym jak „Imię i nazwisko”.
   */
  STREET = 'STREET',
  POSTAL_CODE = 'POSTAL_CODE',
  CITY = 'CITY',
  BIRTH_DATE = 'BIRTH_DATE',
}
